import { render, staticRenderFns } from "./ProjectTasksCard.vue?vue&type=template&id=5a961310&"
import script from "./ProjectTasksCard.vue?vue&type=script&lang=js&"
export * from "./ProjectTasksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports